export class Resumen {
        key: string;
        titulo: string;
        autores: string;
        filacion: string;
        introducion: string;
        objetivo: string;
        metodo: string;
        resultados: string;
        conclusion: string;
        palabrasclaves: string;
        nombreresponsable: string;
        emailresponsable: string;
        active = true;
    }